import { useEffect, useRef, useState } from "react";

const EASE = (t) => 1 - Math.pow(1 - t, 3);

// رقم يعدّ تصاعدياً بسلاسة (الحاوية ثابتة، الرقم فقط يتحرك).
export const CountUp = ({ value = 0, className = "" }) => {
  const [n, setN] = useState(0);
  const from = useRef(0);
  useEffect(() => {
    let f;
    const start = performance.now();
    const a = from.current;
    const tick = (now) => {
      const p = Math.min((now - start) / 900, 1);
      const cur = p < 1 ? a + (value - a) * EASE(p) : value;
      from.current = cur;
      setN(cur);
      if (p < 1) f = requestAnimationFrame(tick);
    };
    f = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(f);
  }, [value]);
  const int = Number.isInteger(value);
  return <span className={`num ${className}`}>{int ? Math.round(n) : n.toFixed(1)}</span>;
};
